import React from "react";
import {
    Div,
    Text,
    Image,
} from "qdm-component-library";

export const Filenameui = (props) => {
    return (
        <Div className="pi-upload-doc" style={{ display: "grid", width:"unset", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Image
                    className="pi-upload-doc-img"
                    style={{ marginRight: "9px" }}
                    src={"images/icons8-document.svg"}
                    alt=""
                />
            </div>
            <Text
                className="pi-upload-doc-name"
                style={{
                    color: "#6F6F6F",
                    fontSize: "14px",
                    wordSpacing: "5px",
                }}
            >
                {props?.fileName ?? ""}
            </Text>
            &nbsp;
            <Div
                style={{
                    width: 15,
                    cursor: "pointer",
                    marginLeft: "11%",
                    width: "15px",
                    height: "13px",
                }}
            >
                <Image
                    src="images/icons8-multiply.svg"
                    alt="delete"
                    // onClick={() => this.removedoc(i)}
                    onClick={props.delete}
                />
            </Div>
        </Div>
    )
}